import type { Kiln, Segment } from "../types";
import { parseRateValue, parseSegmentNumber } from "./unitHelpers";

interface TimedSegment extends Omit<Segment, "temperature"> {
  temperature: string;
}

export const convertSegmentsToTimedController = (
  segments: Segment[],
  kiln?: Kiln
): (Segment | TimedSegment)[] => {
  const timed_controller = kiln?.timed_controller;
  const ambient_temperature = kiln?.ambient_temperature || "18";

  // If it's not a timed controller, just return the segments un-ruined.
  if (!timed_controller) {
    return segments;
  }

  let last_temperature = Number(ambient_temperature);
  const fixed_segments: TimedSegment[] = [];
  for (const segment of segments) {
    const rate = parseRateValue(segment.rate);
    const temp = parseSegmentNumber(segment.temperature);
    const timeToTemperature =
      rate > 0 ? Math.abs(((temp - last_temperature) / rate) * 60) : 0;
    const minsToTemperature = Math.round(timeToTemperature % 60)
      .toString()
      .padStart(2, "0");
    const hoursToTemperature = Math.round((timeToTemperature - Number(minsToTemperature)) / 60);
    last_temperature = temp;
    fixed_segments.push({
      ...segment,
      temperature: `${hoursToTemperature}:${minsToTemperature}`,
    });
  }
  return fixed_segments;
};
